import {React, _, observer, classNames, useCallback} from '@api'
import {useGroupByGroupStore, NoImagePlaceholder, useGroupBySwatchesStore, useCardFieldStore} from '@modules'
import { ICatalogFieldConfig, LibraryItemConfig, useCatalog} from '@stores'
import {MyImage, ImagePlaceholder} from 'centric-ui-components'
import {toJS} from 'mobx'
import * as css from './GroupSwatch.css'

export const GroupSwatch = observer<{ className?: string, borderIfObjectFitCover?: boolean, emptyContents?: React.ReactElement<any> }>(function GroupSwatch({emptyContents, className, borderIfObjectFitCover}) {
  const groupStore = useGroupByGroupStore(),
    cardFieldStore = useCardFieldStore(),
    data = cardFieldStore?.value?.val ?? groupStore?.esInfo,
    library = cardFieldStore?.library ?? groupStore?.grouping?.library

  if (!data || !library) return emptyContents ?? null

  return <GroupSwatchDiv className={className} data={data} library={library} />
})

export const GroupSwatchDiv = observer<{ className?: string, data?: any, library: LibraryItemConfig }>(function GroupSwatchDiv({className, data, library}) {
  const catalog = useCatalog(),
    dataMap = catalog.dataMapForLibrary(library),
    images = _.get(data, dataMap.images),
    image: any = _.first(images),
    workspace = catalog.workspaceByIndex[library.index]

  return <div
    className={classNames(css.root, className)}
    data-no-image={!image}
    data-type='GroupSwatch'
    data-object-fit={catalog.objectFitFor(workspace)}
  >
    {!image ? <NoImagePlaceholder className={css.noImage} placeholderText={_.first(library.name)}/>
            : image.hex ? <div style={{background: image.hex}} className={css.hex}/>
                        : <MyImage
                className={css.image}
                imageUrl={catalog.imageUrlFor(image)}
                width={40}
                height={40}
                blurOnLoad

                //loader={<LoadingImagePlaceholder/>}
              />}
  </div>
})

export const SpecSwatch = observer<{className?: string, item: any, esIndex: string, field: ICatalogFieldConfig} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, HTMLDivElement>(({className, item, field, esIndex, ...props}, ref) => {
  const catalog = useCatalog(),
    library = catalog.libraryByIndex[esIndex],
    dataMap = catalog.dataMapForLibrary(library),
    images = _.get(item, dataMap.images),
    id = catalog.idFor(item),
    store = useGroupBySwatchesStore(),
    {swatchMouseEventsFor, groupStore: {matchesContextualCatalogItem}, selectedSwatches} = store,
    onContextMenu = useCallback((e: React.MouseEvent) => store.onContextMenu(e, {item, esIndex, field}), [item, esIndex, field]),
    associatedWorkspace = catalog.workspaceByIndex[library?.index ?? catalog?.index]

  // console.log({item, images})
  return (_.isEmpty(images) ? [null] : images).map(
    (image, i) => (
      <div key={i}
           ref={ref}
           onContextMenu={onContextMenu}
           data-type='swatch'
           data-renderer={field.renderer}
           data-no-image={!!image}
           data-selected={selectedSwatches.has(id)}
           data-swatch-image-index={i}
           data-matches-hover-item={matchesContextualCatalogItem(item, field.field)}
           className={classNames(css.root, className)}
           {...swatchMouseEventsFor({item, field, image})}
           {...props}>
        {!image ? field.renderer === 'text' ? <div className={css.specText}>{item?.name}<span className={css.count}></span></div>
                : <NoImagePlaceholder placeholderText={_.first(library?.name ?? catalog.labelForField(field))}/>
                : image.hex ? <div style={{background: image.hex}} className={css.hex}/>
                            : <MyImage
                    className={css.image}
                    imageUrl={catalog.imageUrlFor(image)}
                    blurOnLoad
                    style={{'--image-source-object-fit': associatedWorkspace?.catalog?.features?.card?.objectFit ?? undefined} as any}
                    //loader={<LoadingImagePlaceholder/>}
                  />}
      </div>))
}, {forwardRef: true})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupSwatch.tsx